module.exports = __webpack_public_path__ + "static/slide-1-c5aa210a6c3aff7cbb02e3f07c97459d.jpg";